export const numToPriceUtil = (n, currency,) => (
	(currency !== '₽' ? `${currency} ` : '') +
	n.toFixed(0,).replace(/./g, (c, i, a,) => (i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ` ${c}` : c),) +
	(currency === '₽' ? ` ${currency}` : ''))
